import React from 'react';
import { Filter, X } from 'lucide-react';

const FilterPresets = ({
  onApplyPreset,
  activePreset = null,
  extraPresets = [],
  className = ""
}) => {
  const basePresets = [
    {
      id: 'overdue',
      label: 'Overdue',
      description: 'Show all overdue items',
      color: 'bg-red-100 text-red-700 border-red-200'
    },
    {
      id: 'due-this-week',
      label: 'Due This Week',
      description: 'Items due in the next 7 days',
      color: 'bg-amber-100 text-amber-700 border-amber-200'
    },
    {
      id: 'due-this-month',
      label: 'Due This Month',
      description: 'Items due in the next 30 days',
      color: 'bg-orange-100 text-orange-700 border-orange-200'
    },
    {
      id: 'unassigned',
      label: 'Unassigned',
      description: 'Items not assigned to staff',
      color: 'bg-slate-100 text-slate-700 border-slate-200'
    },
    {
      id: 'with-notes',
      label: 'Has Notes',
      description: 'Items with client notes',
      color: 'bg-blue-100 text-blue-700 border-blue-200'
    }
  ];

  const presets = [...basePresets, ...extraPresets];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1 text-xs text-slate-500 font-medium">
        <Filter className="w-3.5 h-3.5" />
        <span>Quick Filters:</span>
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        {presets.map(preset => (
          <button
            key={preset.id}
            onClick={() => onApplyPreset(preset.id)}
            className={`px-2 py-1 text-xs font-medium rounded border transition-all ${
              activePreset === preset.id
                ? `${preset.color} shadow-sm`
                : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50 hover:border-slate-300'
            }`}
            title={preset.description}
          >
            {preset.label}
          </button>
        ))}
        {activePreset && (
          <button
            onClick={() => onApplyPreset(null)}
            className="px-2 py-1 text-xs font-medium rounded border bg-red-50 border-red-200 text-red-600 hover:bg-red-100 transition-all"
            title="Clear all filters"
          >
            <X className="w-3 h-3" />
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterPresets;